import { render, staticRenderFns } from "./VShortAnswer.vue?vue&type=template&id=7a7cbc60&scoped=true"
import script from "./VShortAnswer.vue?vue&type=script&lang=js"
export * from "./VShortAnswer.vue?vue&type=script&lang=js"
import style0 from "./VShortAnswer.vue?vue&type=style&index=0&id=7a7cbc60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7cbc60",
  null
  
)

export default component.exports